module.exports = __webpack_public_path__ + "media/fonts/Oricons-6d84d63549ee9a24d950968f593d681c.eot";